<div class="loader" [hidden]="status != LOADING">
    <div class="dimmed">
        <div class="dimmed_title"></div>
    </div>
</div>
<div *ngIf="status == DONE" class="version-related-group">
    <header class="counter-header" [hidden]="total==0">
        <h5>
            <em>{{total}}</em>
            <span [hidden]="total > 1">Version</span>
            <span [hidden]="total < 2">Versions</span>
        </h5>
    </header>
    <div>
        <ul class="version-related-group-list" >
            <li *ngFor="let group of groups">
                <core-versions-related-group-item-files-list-checkbox
                  [related]="group"
                  [selected]="selected"
                  (selectedChange)="onChange($event);"
                  [disabled]="disabled"
                 ></core-versions-related-group-item-files-list-checkbox>
            </li>
        </ul>
    </div>
</div>
